import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import Moment from "react-moment";
import StageTimeline from "../stage/StageTimeline";
import { drawAasmState } from "../commons/Functions";

const CoursePostulation = ({ postulation }) => {
  const { course = {} } = postulation;
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(o => !o);

  const showTrabajandoIcon =
    postulation.is_trabajando || course.trabajando_publication?.id;

  const trabajandoImgSrc = postulation.is_trabajando
    ? RAILS_ASSET_URL("/images/trabajando_active_icon64.png")
    : course.trabajando_publication?.aasm_state === "active"
      ? RAILS_ASSET_URL("/images/trabajando_active.png")
      : course.trabajando_publication?.aasm_state === "in_draft"
        ? RAILS_ASSET_URL("/images/trabajando_inactive.png")
        : RAILS_ASSET_URL("/images/trabajando_deactive.png");

  return (
    <Card className="mb-3 publication-list-item job-card">
      <CardBody>
        <div className="row align-items-center">
          <div className="col-12 col-lg-6 pe-lg-3">
            <h2 className="h5 mb-3 fw-bold">
              {course.title}&nbsp;
              {drawAasmState(course.aasm_state)}
              {showTrabajandoIcon && (
                <img
                  src={trabajandoImgSrc}
                  alt="Trabajando"
                  className="trabajando-icon ms-1"
                  title="Trabajando"
                />
              )}
            </h2>

            <ul className="fa-ul list-unstyled mb-0 ms-4 publication-detail-list">
              <li>
                <span className="fa-li">
                  <i className="far fa-calendar-alt" />
                </span>
                <Moment format="DD/MM/YYYY">{course.createdAt}</Moment>&nbsp;
                {drawAasmState(course.minisite_publication?.aasm_state)}
              </li>
              <li>
                <span className="fa-li">
                  <i className="fas fa-business-time" />
                </span>
                {course.minisite_publication?.preferred_schedule || "Jornada no indicada"}
              </li>
              <li>
                <span className="fa-li">
                  <i className="fas fa-map-marker-alt" />
                </span>
                {course.minisite_publication?.commune?.name},{" "}
                {course.minisite_publication?.region?.name}.
              </li>
            </ul>
          </div>

          <div className="col-12 col-lg-4">
            <div className="timeline-col d-flex justify-content-center justify-content-lg-start">
              <StageTimeline
                postulationState={postulation.aasm_state}
                postulatedAt={postulation.created_at}
                stages={postulation.applicant?.enrollment?.stages || []}
                workFlow={course.workflow || []}
              />
            </div>
          </div>

          <div className="col-12 col-lg-2 text-lg-end mt-3 mt-lg-0 d-flex justify-content-lg-end">
            <Button
              size="sm"
              color="primary"
              className="my-2 my-lg-0"
              href={`/courses/${course.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver Proceso
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default CoursePostulation;
